export enum NOTE_UPLOAD_METHOD {
  EHR_BUTTON = 'EHR_BUTTON',
  MDS_BUTTON = 'MDS_BUTTON',
}
